import { styled, Typography } from "@mui/material";

export const NotFoundContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
    padding: "15px",
    backgroundColor: "#f0f2f5",
  }));
  
  export const MessageBox = styled("div")(() => ({
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    backgroundColor: "#fff",
    maxWidth: "400px",
    textAlign: "center",
    animation: "fadeIn 1s ease-in-out",
    "@keyframes fadeIn": {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
  }));
  
  export const ErrorMessage = styled(Typography)(({ theme }) => ({
    fontSize: "1.5rem",
    fontWeight: "600",
    color: "#FF0000",
    marginBottom: "15px",
    animation: "bounce 1.5s infinite",
    "@keyframes bounce": {
      "0%, 100%": { transform: "translateY(0)" },
      "50%": { transform: "translateY(-5px)" },
    },
  }));
  
  export const Description = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    color: "#666",
    opacity: 0.8,
    marginBottom: "20px",
  }));